<template>
<div class="writeoffCodeDialog" v-if="dialogVisible">
    <el-dialog title="总核销码" :visible.sync="dialogVisible" @close="cancel" width="400px">
        <div class="share">
            <div class="box">
                <img :src="imgBase64" alt="邀请链接" class="img">
                <div class="pr-code-text cursor tc-blue" @click="download(imgBase64, '总核销码')">下载总核销码</div>
                <div class="btns">
                    <el-input v-model.trim="inviteurlurl" placeholder="" disabled></el-input>
                    <el-button type="primary" size="mini" v-clipboard:copy="inviteurlurl" v-clipboard:success="onCopy" v-clipboard:error="onError">复制</el-button>
                </div>
            </div>
        </div>
    </el-dialog>
</div>
</template>

<script>
import {downloadImage} from 'common/js/tools'
export default {
    name: 'writeoffCodeDialog',
    data() {
        return {
            dialogVisible: false,
            inviteurlurl: '',
            imgBase64: ''
        }
    },
    mounted() {
    },
    methods: {
        openDialog(url, inviteurlurl) {
            this.dialogVisible = true
            this.imgBase64 = url
            this.inviteurlurl = inviteurlurl
        },
        cancel() {
            this.dialogVisible = false
        },
        download(imgsrc, name) {
            downloadImage(imgsrc, name)
        },
        onCopy(e) {
            this.$message({
                message: '复制成功',
                type: 'success'
            })
        },
        onError(e) {
            alert('失败')
        },
    },
    filters: {},
    watch: {},
    computed: {},
    components: {}
}
</script>

<style lang="scss" type="text/scss" rel="stylesheet/scss">
@import "~common/scss/mixin";
.writeoffCodeDialog {
    .share{
        @include flexBox(space-around);
        .box{
            display: flex;
            flex-direction: column;
            justify-content: center;
            align-items: center;
            .btns{
                display: flex;
                margin: 10px 0;
                .el-button{
                    margin:0;
                }
            }
            .img{
                width: 300px;
                height: 360px;
            }
        }
        .box+.box{
            margin-left: 20px;
        }
    }
}
</style>
